import { put, takeLatest} from "redux-saga/effects";
import {RESET_ERROR_MSG, SET_ERROR_MSG} from "@actions/actionTypes";

function* setErrorMsg({value}) {
     yield put({type: SET_ERROR_MSG,  data: {type: "error", messages: value}});
}

export default function* () {
    yield takeLatest(RESET_ERROR_MSG, setErrorMsg);
}